import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { PageLayout } from '../../../shared/layout/page/PageLayout';
import { IAccountDetailsPageData } from '../../domain/pages/IAccountDetailsPageData';
import { AccountPageHeader } from './AccountPageHeader';
import { CurrentTierPoints } from '../current-tier-points/CurrentTierPoints';
import { MyBookings } from '../../../parking/ui/my-bookings/overview';
import {
	getOverlapWithHeaderStyles,
	StyledHeader,
} from '../../../shared/components';
import { AccountShortcutsSection } from './AccountShortcutsSection';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { useAuthStore } from '../../../auth/shared/store/useAuthStore';
import { useLoyaltyAccountStore } from '../../domain/stores/useLoyaltyAccountStore';
import { SignOutShortcut } from './SignOutShortcut';
import { PageMetaData } from '../../../shared/layout/page/PageMetaData';
import { useIsHydrated } from '../../../auth/shared/store/useIsHydrated';
import { useRedirectIfNotAuthenticated } from '../../../auth/shared/store/useRedirectIfNotAuthenticated';

interface IAccountPageProps extends IAccountDetailsPageData {}

export const AccountPage = observer(({ page }: IAccountPageProps) => {
	const { isAuthenticated } = useAuthStore();
	const isHydrated = useIsHydrated();
	const loyaltyDetailsStore = useLoyaltyAccountStore();

	const redirectUrl = useUrlForPageId(PassengersPageId.Home);
	useRedirectIfNotAuthenticated(redirectUrl);

	if (!isAuthenticated || !isHydrated) {
		// We need to return metadata here, otherwise no <title> is rendered server-side, causing accessibility checks to fail.
		return <PageMetaData page={page} />;
	}

	return (
		<PageLayout page={page} overlapContentWithHeader>
			<AccountPageHeader page={page} />
			<StyledContentWrap backgroundTheme="purple-blue">
				<CurrentTierPoints store={loyaltyDetailsStore} />
				<AccountShortcutsSection />
			</StyledContentWrap>
			<MyBookings />

			<SignOutShortcut redirectUrl={redirectUrl} />
		</PageLayout>
	);
});

const StyledContentWrap = styled.div`
	${StyledHeader} + style + &,
  	${StyledHeader} + & {
		${getOverlapWithHeaderStyles}
	}
`;
